<!--收款计划-->
<template>
  <div class="collection-plan-container">
    <!-- 查询条件区域 -->
    <el-card class="filter-card" shadow="never">
      <div slot="header" class="card-header">
        <span>查询条件</span>
      </div>
      <el-form
        :inline="true"
        :model="searchForm"
        class="search-form"
        size="small"
      >
        <el-form-item label="合同编号：">
          <el-input
            v-model="searchForm.contractNo"
            placeholder="请输入合同编号"
          ></el-input>
        </el-form-item>
        <el-form-item label="合同名称：">
          <el-input
            v-model="searchForm.contractName"
            placeholder="请输入合同名称"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="合同类型：">
          <el-select
            v-model="searchForm.contractType"
            placeholder="请选择合同类型"
          >
            <el-option label="商铺转让合同" value="1"></el-option>
            <el-option label="广告合同" value="2"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="合同开始时间：">
          <el-date-picker
            v-model="searchForm.startDate"
            type="date"
            placeholder="请输入开始时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="合同结束时间：">
          <el-date-picker
            v-model="searchForm.endDate"
            type="date"
            placeholder="请输入结束时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch"
            >搜索</el-button
          >
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 列表数据区域 -->
    <el-card class="list-card" shadow="never">
      <div slot="header" class="list-header">
        <span class="title">收款计划列表</span>
        <el-button type="primary" size="small" icon="el-icon-plus"
          @click="openAddDialog">新增收款计划</el-button
        >
      </div>

      <!-- 新增收款计划弹窗 -->
      <el-dialog
        :title="isEditMode ? '编辑收款计划' : '新增收款计划'"
        :visible="addDialogVisible"
        :modal="true"
        width="60%"
        center
        :before-close="handleAddDialogClose"
      >
        <div class="dialog-content">
          <!-- 步骤1：选择合同（仅新增时显示） -->
          <div v-if="!isEditMode && !selectedContract" class="contract-select-section">
            <h3>请选择合同：</h3>
            <el-table
              :data="contractList"
              style="width: 100%"
              size="small"
              row-key="id"
              highlight-current-row
              v-model="selectedContract"
              @current-change="handleContractSelect"
            >
              <el-table-column
                property="contractName"
                label="合同名称"
                min-width="120"
              >
                <template slot-scope="scope">
                  <el-radio v-model="selectedContractId" :label="scope.row.id">{{scope.row.contractName}}</el-radio>
                </template>
              </el-table-column>
              <el-table-column
                property="contractNo"
                label="合同编号"
                min-width="100"
              ></el-table-column>
              <!-- <el-table-column
                property="parentContractNo"
                label="父合同编号"
                min-width="100"
              ></el-table-column>
              <el-table-column
                property="contractType"
                label="合同类型"
                min-width="100"
              ></el-table-column>
              <el-table-column
                property="operator"
                label="经办人"
                min-width="80"
              ></el-table-column> -->
              <el-table-column
                property="contractAmount"
                label="合同金额"
                align="right"
                min-width="100"
              >
                <template slot-scope="scope">
                  {{ (scope.row.contractAmount || 0).toFixed(2) }}
                </template>
              </el-table-column>
              <el-table-column
                property="partyBName"
                label="合同乙方"
                min-width="100"
              ></el-table-column>
              <el-table-column
                property="expiryDate"
                label="有效期"
                min-width="150"
              ></el-table-column>
            </el-table>
            <!-- 合同列表分页 -->
            <div class="contract-pagination">
              <el-pagination
                @size-change="handleContractSizeChange"
                @current-change="handleContractCurrentChange"
                :current-page="contractPagination.currentPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="contractPagination.pageSize"
                layout="total, prev, pager, next, sizes, jumper"
                :total="contractPagination.total"
              >
              </el-pagination>
            </div>
          </div>

          <!-- 步骤2：填写收款计划详情 -->
          <div v-if="isEditMode || selectedContract" class="plan-detail-section">
            <!-- 合同信息 -->
            <div class="contract-info-section">
              <h4>合同信息</h4>
              <el-descriptions :column="3" size="small" border v-if="selectedContract">
                <el-descriptions-item label="合同名称">{{ selectedContract.contractName }}</el-descriptions-item>
                <el-descriptions-item label="合同编号">{{ selectedContract.contractNo }}</el-descriptions-item>
                <!-- <el-descriptions-item label="合同类型">{{ selectedContract.contractType }}</el-descriptions-item> -->
                <el-descriptions-item label="甲方">{{ selectedContract.partyAName || '-' }}</el-descriptions-item>
                <el-descriptions-item label="甲方联系人">{{ selectedContract.partyAContact || '-' }}</el-descriptions-item>
                <el-descriptions-item label="甲方联系电话">{{ selectedContract.partyAPhone || '-' }}</el-descriptions-item>
                <el-descriptions-item label="乙方">{{ selectedContract.partyBName || '-' }}</el-descriptions-item>
                <el-descriptions-item label="乙方联系人">{{ selectedContract.partyBContact || '-' }}</el-descriptions-item>
                <el-descriptions-item label="乙方联系电话">{{ selectedContract.partyBPhone || '-' }}</el-descriptions-item>
                <el-descriptions-item label="经办人">{{ selectedContract.operator }}</el-descriptions-item>
                <el-descriptions-item label="联系电话">{{ selectedContract.operatorPhone || '-' }}</el-descriptions-item>
                <el-descriptions-item label="合同金额">{{ (selectedContract.contractAmount || 0).toFixed(2) }}</el-descriptions-item>
                <el-descriptions-item label="开始时间">{{ selectedContract.effectiveDate || '-' }}</el-descriptions-item>
                <el-descriptions-item label="结束时间">{{ selectedContract.expiryDate || '-' }}</el-descriptions-item>
                <el-descriptions-item label="签订时间">{{ selectedContract.signDate || '-' }}</el-descriptions-item>
              </el-descriptions>
            </div>

            <!-- 收款信息 -->
            <div class="receipt-info-section">
              <h4>收款信息</h4>
              <el-form :model="addPlanForm" label-width="100px" size="small">
                <el-row :gutter="20">
                  <el-col :span="8">
                    <el-form-item label="付款人" required>
                      <el-input v-model="addPlanForm.payer" placeholder="请输入"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="联系方式" required>
                      <el-input v-model="addPlanForm.contactInfo" placeholder="请输入"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="收款类型" required>
                      <el-input v-model="addPlanForm.receiptType" placeholder="请输入"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>

            <!-- 月结分账 -->
            <div class="installment-section">
              <h4>月结分账</h4>
              <el-form :model="addPlanForm" label-width="100px" size="small">
                <el-row :gutter="20">
                  <el-col :span="8">
                    <el-form-item label="开始期间">
                      <el-date-picker
                        v-model="addPlanForm.startPeriod"
                        type="date"
                        placeholder="请选择"
                        style="width: 100%"
                        value-format="yyyy-MM-dd"
                        @change="generateInstallmentList"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="结束期间">
                      <el-date-picker
                        v-model="addPlanForm.endPeriod"
                        type="date"
                        placeholder="请选择"
                        style="width: 100%"
                        value-format="yyyy-MM-dd"
                        @change="generateInstallmentList"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item label="付款周期">
                  <el-radio-group v-model="addPlanForm.paymentCycle" @change="generateInstallmentList">
                    <el-radio label="monthly">逐月</el-radio>
                    <el-radio label="quarterly">逐季</el-radio>
                    <el-radio label="yearly">年一次</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="付款附言">
                  <el-input
                    v-model="addPlanForm.paymentRemark"
                    type="textarea"
                    :rows="2"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-form>

              <!-- 分账明细表格 -->
              <div class="installment-table">
                <el-table :data="addPlanForm.installmentList" size="small" border>
                  <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                  <el-table-column label="开始日期" min-width="150">
                    <template slot-scope="scope">
                      {{ scope.row.startDate }}
                    </template>
                  </el-table-column>
                  <el-table-column label="结束日期" min-width="150">
                    <template slot-scope="scope">
                      {{ scope.row.endDate }}
                    </template>
                  </el-table-column>
                  <el-table-column label="金额" min-width="120">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.amount" size="small" placeholder="请输入金额"></el-input>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="installment-total">
                  预计分账金额：{{ calculateTotalAmount }} 元
                </div>
              </div>
            </div>

            <!-- 收入分成 -->
<!--            <div class="revenue-share-section">-->
<!--              <h4>收入分成</h4>-->
<!--              <el-button type="primary" size="small" icon="el-icon-plus" @click="handleAddRevenueShare">添加分账</el-button>-->
<!--              <div v-if="addPlanForm.revenueShareList.length > 0" class="revenue-share-list">-->
<!--                <div v-for="(item, index) in addPlanForm.revenueShareList" :key="index" class="revenue-share-item">-->
<!--                  <el-form :model="item" label-width="80px" size="small">-->
<!--                    <el-row :gutter="10">-->
<!--                      <el-col :span="6">-->
<!--                        <el-form-item label="分成方">-->
<!--                          <el-input v-model="item.party" placeholder="请输入"></el-input>-->
<!--                        </el-form-item>-->
<!--                      </el-col>-->
<!--                      <el-col :span="6">-->
<!--                        <el-form-item label="分成比例">-->
<!--                          <el-input v-model="item.ratio" placeholder="%">-->
<!--                            <template slot="append">%</template>-->
<!--                          </el-input>-->
<!--                        </el-form-item>-->
<!--                      </el-col>-->
<!--                      <el-col :span="6">-->
<!--                        <el-form-item label="分成金额">-->
<!--                          <el-input v-model="item.amount" placeholder="请输入"></el-input>-->
<!--                        </el-form-item>-->
<!--                      </el-col>-->
<!--                      <el-col :span="6">-->
<!--                        <el-button type="danger" size="small" icon="el-icon-delete" @click="handleDeleteRevenueShare(index)">删除</el-button>-->
<!--                      </el-col>-->
<!--                    </el-row>-->
<!--                  </el-form>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addDialogVisible = false">取消</el-button>
          <el-button v-if="!isEditMode && !selectedContract" type="primary" @click="handleNextStep" :disabled="!selectedContractId">下一步</el-button>
          <el-button v-if="isEditMode || selectedContract" type="primary" @click="handleSavePlan">确定</el-button>
        </span>
      </el-dialog>

      <!-- 执行收款弹窗 -->
      <el-dialog
        title="执行收款"
        :visible="addReceiptVisible"
        :modal="true"
        width="500px"
        center
        :before-close="handleAddReceiptClose"
      >
        <div class="add-receipt-dialog">
          <el-form :model="addReceiptForm" label-width="100px" size="small">
            <el-form-item label="合同编号">
              <el-input v-model="addReceiptForm.contractNo" readonly></el-input>
            </el-form-item>
            <el-form-item label="收款金额(元)" required>
              <el-input v-model="addReceiptForm.amount" placeholder="请输入收款金额" type="number" min="0" step="0.01"></el-input>
            </el-form-item>
            <el-form-item label="收款日期" required>
              <el-date-picker
                v-model="addReceiptForm.receiptDate"
                type="date"
                placeholder="Select date"
                style="width: 100%"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="收款方式" required>
              <el-select v-model="addReceiptForm.receiptType" placeholder="请选择收款方式" style="width: 100%">
                <el-option label="现金" value="cash"></el-option>
                <el-option label="银行转账" value="bank"></el-option>
                <el-option label="支付宝" value="alipay"></el-option>
                <el-option label="微信" value="wechat"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="备注">
              <el-input
                v-model="addReceiptForm.remark"
                type="textarea"
                :rows="3"
                placeholder="请输入备注"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addReceiptVisible = false">取消</el-button>
          <el-button type="primary" @click="handleAddReceipt">确定</el-button>
        </span>
      </el-dialog>

      <!-- 状态切换标签 -->
      <el-tabs
        v-model="activeStatus"
        @tab-click="handleTabClick"
        class="status-tabs"
      >
        <el-tab-pane
          v-for="item in statusOptions"
          :key="item.value"
          :label="item.label"
          :name="item.value"
        ></el-tab-pane>
      </el-tabs>

      <!-- 表格区域 -->
      <el-table
        :data="tableData"
        style="width: 100%"
        size="small"
        :header-cell-style="headerCellStyle"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column
          label="序号"
          width="50"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.$index + 1 + (pagination.currentPage - 1) * pagination.pageSize }}
          </template>
        </el-table-column>
        <el-table-column
          property="contractNo"
          label="合同编号"
          min-width="100"
        ></el-table-column>
        <el-table-column
          property="contractName"
          label="合同名称"
          min-width="120"
        ></el-table-column>
        <!-- <el-table-column
          property="contractType"
          label="合同类型"
          min-width="100"
        ></el-table-column> -->
        <el-table-column
          property="contractPartyInfo"
          label="合作方信息"
          min-width="150"
        ></el-table-column>
        <el-table-column
          property="planAmount"
          label="签约金额(元)"
          align="right"
          min-width="100"
        >
          <template slot-scope="scope">{{
            (scope.row.planAmount || 0).toFixed(2)
          }}</template>
        </el-table-column>
        <el-table-column
          property="executedAmount"
          label="已执行金额(元)"
          align="right"
          min-width="120"
        >
          <template slot-scope="scope">{{
            (scope.row.executedAmount || 0).toFixed(2)
          }}</template>
        </el-table-column>
        <el-table-column label="执行进度" min-width="180">
          <template slot-scope="scope">
            <div class="progress-wrapper">
              <el-progress
                :percentage="scope.row.executionProgress"
                :color="getProgressColor(scope.row.status)"
                :format="(val) => val + '%'"
                :stroke-width="8"
              >
              </el-progress>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          property="contractStartDate"
          label="合同开始时间"
          width="100"
        ></el-table-column>
        <el-table-column
          property="contractEndDate"
          label="合同结束时间"
          width="100"
        ></el-table-column>
        <el-table-column label="状态" width="80">
          <template slot-scope="scope">
            <span :style="{ color: getStatusColor(scope.row.status) }">{{
              scope.row.statusName
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="220" fixed="right">
          <template slot-scope="scope">
            <el-button
                type="text"
                size="small"
                v-if="scope.row.status === 'PENDING' || scope.row.status === 'EXECUTING'"
                @click="handleEditPlan(scope.row)">编辑</el-button
            >
            <el-button
              type="text"
              size="small"
              v-if="
                scope.row.status !== '已终止' && scope.row.status !== '已完成'
              "
              @click="handleAddReceiptClick(scope.row)">新增收款</el-button
            >
            <el-button type="text" size="small" class="btn-delete"
              @click="handleDeletePlan(scope.row.id)">删除计划</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.pageSize"
          layout="total, prev, pager, next, sizes, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import { pageQueryContracts } from '@/api/assets/occupancyMapApi.js'
import { getCollectionPlanPage, getCollectionPlanDetail, saveCollectionPlan, updateCollectionPlan, deleteCollectionPlan, saveReceiptRecord } from '@/api/plan/collectionPlanApi'
import { getCommunityId } from '@/utils/vc.js'

export default {
  name: "CollectionPlan",
  data() {
    return {
      // 搜索表单数据
      searchForm: {
        contractNo: "",
        contractName: "",
        contractType: "",
        startDate: "",
        endDate: "",
      },
      // 当前激活的状态标签
      activeStatus: "",
      // 状态选项
      statusOptions: [
        { label: "全部", value: "" },
        { label: "待执行", value: "PENDING" },
        { label: "执行中", value: "EXECUTING" },
        { label: "已完成", value: "COMPLETED" },
        { label: "已终止", value: "TERMINATED" },
      ],
      // 新增收款计划弹窗
      addDialogVisible: false,
      // 执行收款弹窗
      addReceiptVisible: false,
      // 选中的合同
      selectedContract: null,
      selectedContractId: null,
      // 选中的收款计划
      selectedPlan: null,
      // 执行收款表单数据
      addReceiptForm: {
        contractNo: "",
        amount: "",
        receiptDate: new Date(),
        receiptType: "",
        remark: ""
      },
      // 合同列表数据
      contractList: [],
      // 合同列表分页配置
      contractPagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      // 合同查询参数
      contractQueryParams: {
        contractNo: "",
        contractName: "",
        startDate: "",
        endDate: ""
      },
      // 新增收款计划步骤控制
      addPlanStep: 1, // 1: 选择合同, 2: 填写详情
      // 编辑模式
      isEditMode: false,
      // 编辑的收款计划ID
      editPlanId: null,
      // 新增收款计划表单数据
      addPlanForm: {
        // 收款信息
        payer: "",
        contactInfo: "",
        receiptType: "",
        // 月结分账
        startPeriod: "",
        endPeriod: "",
        paymentCycle: "monthly", // monthly: 逐月, quarterly: 逐季, yearly: 年一次
        paymentRemark: "",
        // 分账明细列表
        installmentList: [],
        // 收入分成
        revenueShareList: []
      },
      // 表格数据
      tableData: [],
      // 分页配置
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      // 收款计划查询参数
      planQueryParams: {
        contractName: "",
        contractNo: "",
        executionProgress: 0,
        page: 1,
        planNo: "",
        size: 10,
        status: ""
      },
      // 表头背景色样式
      headerCellStyle: {
        backgroundColor: "#f8f9fb",
        color: "#333",
        fontWeight: "bold",
      },
    };
  },
  computed: {
    // 计算分账总金额
    calculateTotalAmount() {
      if (!this.addPlanForm.installmentList || this.addPlanForm.installmentList.length === 0) {
        return 0;
      }
      return this.addPlanForm.installmentList.reduce((total, item) => {
        return total + (parseFloat(item.amount) || 0);
      }, 0).toFixed(2);
    }
  },
  watch: {
    // // 监听开始期间变化
    // 'addPlanForm.startPeriod': function() {
    //   this.generateInstallmentList();
    // },
    // // 监听结束期间变化
    // 'addPlanForm.endPeriod': function() {
    //   this.generateInstallmentList();
    // },
    // // 监听付款周期变化
    // 'addPlanForm.paymentCycle': function() {
    //   this.generateInstallmentList();
    // }
  },
  mounted() {
    console.log("收款计划页面已加载");
    this.loadCollectionPlan();
  },
  methods: {
    // 搜索事件
    handleSearch() {
      console.log("执行搜索", this.searchForm);
      this.pagination.currentPage = 1;
      this.planQueryParams.page = 1;
      this.planQueryParams.contractName = this.searchForm.contractName;
      this.planQueryParams.contractNo = this.searchForm.contractNo;
      this.loadCollectionPlan();
    },
    // 标签页切换
    handleTabClick(tab) {
      console.log("切换状态：", tab.name);
      this.pagination.currentPage = 1;
      this.planQueryParams.page = 1;
      this.planQueryParams.status = tab.name;
      this.loadCollectionPlan();
    },
    // 加载收款计划列表
    loadCollectionPlan() {
      const params = {
        ...this.planQueryParams,
        communityId: getCommunityId(),
        page: this.pagination.currentPage,
        size: this.pagination.pageSize
      };
      getCollectionPlanPage(params).then(res => {
        if (res.code === 0) {
          this.tableData = res.data.records;
          this.pagination.total = res.data.total;
        } else {
          this.$message.error(res.message || "加载收款计划失败");
        }
      }).catch(error => {
        console.error("加载收款计划失败：", error);
        this.$message.error("加载收款计划失败");
      });
    },
    // 分页：每页条数改变
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.planQueryParams.size = val;
      this.loadCollectionPlan();
    },
    // 分页：当前页改变
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.planQueryParams.page = val;
      this.loadCollectionPlan();
    },
    // 根据状态获取文字颜色
    getStatusColor(status) {
      const colors = {
        待执行: "#f3a44d", // 橙色
        执行中: "#409eff", // 蓝色
        已完成: "#67c23a", // 绿色
        已终止: "#909399", // 灰色
      };
      return colors[status] || "#606266";
    },
    // 根据状态获取进度条颜色
    getProgressColor(status) {
      if (status === "已完成") return "#67c23a";
      if (status === "已终止") return "#909399";
      return "#409eff";
    },
    // 打开新增收款计划弹窗
    openAddDialog() {
      this.addDialogVisible = true;
      this.selectedContract = null;
      this.contractPagination.currentPage = 1;
      this.loadContractList();
    },
    // 加载合同列表
    loadContractList() {
      const params = {
        page: this.contractPagination.currentPage,
        size: this.contractPagination.pageSize
      };
      pageQueryContracts(params).then(res => {
        this.contractList = res.data.data.records || [];
        this.contractPagination.total = res.data.data.total;
      }).catch(error => {
        console.error("加载合同列表失败：", error);
        this.$message.error("加载合同列表失败");
      });
    },
    // 合同列表分页：每页条数改变
    handleContractSizeChange(val) {
      this.contractPagination.pageSize = val;
      this.loadContractList();
    },
    // 合同列表分页：当前页改变
    handleContractCurrentChange(val) {
      this.contractPagination.currentPage = val;
      this.loadContractList();
    },
    // 处理合同选择
    handleContractSelect(currentRow, oldCurrentRow) {
      this.selectedContract = currentRow;
      this.selectedContractId = currentRow.id;
      console.log("选中的合同：", this.selectedContract);
    },
    // 处理弹窗关闭
    handleAddDialogClose(done) {
      this.addPlanStep = 1;
      this.selectedContract = null;
      this.resetAddPlanForm();
      this.addDialogVisible = false;
      this.isEditMode = false;
      this.editPlanId = null;
      done();
    },
    // 处理执行收款弹窗关闭
    handleAddReceiptClose(done) {
      this.selectedPlan = null;
      this.resetAddReceiptForm();
      this.addReceiptVisible = false;
      done();
    },
    // 重置执行收款表单
    resetAddReceiptForm() {
      this.addReceiptForm = {
        contractNo: "",
        amount: "",
        receiptDate: new Date(),
        receiptType: "",
        remark: ""
      };
    },
    // 处理新增收款按钮点击
    handleAddReceiptClick(row) {
      this.selectedPlan = row;
      this.addReceiptForm.contractNo = row.contractNo || "";
      this.addReceiptVisible = true;
    },
    // 处理编辑计划按钮点击
    handleEditPlan(row) {
      this.isEditMode = true;
      this.editPlanId = row.id;
      this.addDialogVisible = true;
      // 加载收款计划详情
      this.loadPlanDetail(row.id);
    },
    // 加载收款计划详情
    loadPlanDetail(id) {
      getCollectionPlanDetail(id).then(res => {
        if (res.code === 0 && res.data) {
          const plan = res.data;
          // 填充合同信息
          this.selectedContract = plan.contract || {};
          // 填充表单数据
          this.addPlanForm = {
            payer: plan.payer,
            contactInfo: plan.contactInfo,
            receiptType: plan.receiptType,
            startPeriod: plan.startPeriod,
            endPeriod: plan.endPeriod,
            paymentCycle: plan.paymentCycle,
            paymentRemark: plan.paymentRemark,
            installmentList: plan.installmentList || [],
            revenueShareList: plan.revenueShareList || []
          };
        } else {
          this.$message.error(res.message || "加载收款计划详情失败");
        }
      }).catch(error => {
        console.error("加载收款计划详情失败：", error);
        this.$message.error("加载收款计划详情失败");
      });
    },
    // 处理执行收款
    handleAddReceipt() {
      // 表单验证
      if (!this.addReceiptForm.amount || parseFloat(this.addReceiptForm.amount) <= 0) {
        this.$message.warning("请输入有效的收款金额");
        return;
      }
      if (!this.addReceiptForm.receiptDate) {
        this.$message.warning("请选择收款日期");
        return;
      }
      if (!this.addReceiptForm.receiptType) {
        this.$message.warning("请选择收款方式");
        return;
      }

      // 准备收款数据
      const receiptData = {
        amount: parseFloat(this.addReceiptForm.amount),
        contractId: this.selectedPlan.contractId || null,
        contractNo: this.addReceiptForm.contractNo,
        planId: this.selectedPlan.id,
        receiptDate: this.addReceiptForm.receiptDate,
        receiptMethod: this.addReceiptForm.receiptType,
        remark: this.addReceiptForm.remark
      };

      // 调用新增收款记录API
      saveReceiptRecord(receiptData).then(res => {
        if (res.code === 0 && res.data) {
          this.$message.success("收款成功");
          this.addReceiptVisible = false;
          this.selectedPlan = null;
          this.resetAddReceiptForm();
          this.loadCollectionPlan();
        } else {
          this.$message.error(res.message || "收款失败");
        }
      }).catch(error => {
        console.error("收款失败：", error);
        this.$message.error("收款失败");
      });
    },
    // 重置新增收款计划表单
    resetAddPlanForm() {
      this.addPlanForm = {
        payer: "",
        contactInfo: "",
        receiptType: "",
        startPeriod: "",
        endPeriod: "",
        paymentCycle: "monthly",
        paymentRemark: "",
        installmentList: [],
        revenueShareList: []
      };
    },
    // 处理下一步按钮点击
    handleNextStep() {
      if (!this.selectedContract) {
        this.$message.warning("请选择合同");
        return;
      }
      // 根据合同信息生成分账明细
      this.generateInstallmentList();
    },
    // 处理保存收款计划
    handleSavePlan() {
      // 表单验证
      if (!this.addPlanForm.payer) {
        this.$message.warning("请输入付款人");
        return;
      }
      if (!this.addPlanForm.contactInfo) {
        this.$message.warning("请输入联系方式");
        return;
      }
      if (!this.addPlanForm.receiptType) {
        this.$message.warning("请输入收款类型");
        return;
      }

      // 处理分期列表数据

      // 准备保存数据 - 按照接口文档参数
      let planData;

      if (this.isEditMode) {
        // 编辑模式 - 使用更新接口参数
        planData = {
          id: this.editPlanId,
          payer: this.addPlanForm.payer,
          contactInfo: this.addPlanForm.contactInfo,
          receiptType: this.addPlanForm.receiptType,
          startPeriod: this.addPlanForm.startPeriod,
          endPeriod: this.addPlanForm.endPeriod,
          paymentCycle: this.addPlanForm.paymentCycle,
          paymentRemark: this.addPlanForm.paymentRemark,
          installmentList: this.addPlanForm.installmentList,
          lastReceiptDate: this.addPlanForm.endPeriod,
          planAmount: parseFloat(this.calculateTotalAmount) || 0,
        };
      } else {
        // 新增模式 - 使用保存接口参数
        planData = {
          contractId: this.selectedContract.id,
          payer: this.addPlanForm.payer,
          contactInfo: this.addPlanForm.contactInfo,
          receiptType: this.addPlanForm.receiptType,
          startPeriod: this.addPlanForm.startPeriod,
          endPeriod: this.addPlanForm.endPeriod,
          paymentCycle: this.addPlanForm.paymentCycle,
          paymentRemark: this.addPlanForm.paymentRemark,
          installmentList: this.addPlanForm.installmentList,
          lastReceiptDate: this.addPlanForm.endPeriod,
          planAmount: parseFloat(this.calculateTotalAmount) || 0
        };
      }

      // 根据模式调用不同的API
      const apiMethod = this.isEditMode ? updateCollectionPlan : saveCollectionPlan;
      const successMessage = this.isEditMode ? "更新收款计划成功" : "新增收款计划成功";
      const errorMessage = this.isEditMode ? "更新收款计划失败" : "新增收款计划失败";

      // 调用API
      apiMethod(planData).then(res => {
        if (res.code === 0 && res.data) {
          this.$message.success(successMessage);
          this.addDialogVisible = false;
          this.selectedContract = null;
          this.selectedContractId = null;
          this.resetAddPlanForm();
          this.isEditMode = false;
          this.editPlanId = null;
          this.loadCollectionPlan();
        } else {
          this.$message.error(res.message || errorMessage);
        }
      }).catch(error => {
        console.error(errorMessage + "：", error);
        this.$message.error(errorMessage);
      });
    },
    // 生成分账明细列表（根据付款周期）
    generateInstallmentList() {
      const { startPeriod, endPeriod, paymentCycle } = this.addPlanForm;
      this.addPlanForm.installmentList = [];

      if (!startPeriod || !endPeriod) {
        return;
      }

      const startDate = new Date(startPeriod);
      const endDate = new Date(endPeriod);

      if (startDate > endDate) {
        this.$message.warning("开始期间不能晚于结束期间");
        return;
      }

      let currentDate = new Date(startDate);

      while (currentDate <= endDate) {
        const periodStart = new Date(currentDate);
        let periodEnd = new Date(currentDate);

        switch (paymentCycle) {
          case 'monthly':
            // 逐月：每月1号到月末
            periodEnd.setMonth(periodEnd.getMonth() + 1);
            periodEnd.setDate(0);
            break;
          case 'quarterly':
            // 逐季：每季度第一天到最后一天
            periodEnd.setMonth(periodEnd.getMonth() + 3);
            periodEnd.setDate(0);
            break;
          case 'yearly':
            // 年一次：每年第一天到最后一天
            periodEnd.setFullYear(periodEnd.getFullYear() + 1);
            periodEnd.setDate(0);
            periodEnd.setMonth(11);
            break;
        }

        // 确保结束日期不超过总结束期间
        if (periodEnd > endDate) {
          periodEnd = new Date(endDate);
        }

        // 格式化日期为字符串
        const formatDate = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        };

        this.addPlanForm.installmentList.push({
          startDate: formatDate(periodStart),
          endDate: formatDate(periodEnd),
          amount: ""
        });

        // 移动到下一个周期的开始
        if (paymentCycle === 'monthly') {
          currentDate.setMonth(currentDate.getMonth() + 1);
          currentDate.setDate(1);
        } else if (paymentCycle === 'quarterly') {
          currentDate.setMonth(currentDate.getMonth() + 3);
          currentDate.setDate(1);
        } else if (paymentCycle === 'yearly') {
          currentDate.setFullYear(currentDate.getFullYear() + 1);
          currentDate.setMonth(0);
          currentDate.setDate(1);
        }
      }
    },
    // 添加收入分成
    handleAddRevenueShare() {
      this.addPlanForm.revenueShareList.push({
        party: "",
        ratio: "",
        amount: ""
      });
    },
    // 删除收入分成
    handleDeleteRevenueShare(index) {
      this.addPlanForm.revenueShareList.splice(index, 1);
    },
    // 删除收款计划
    handleDeletePlan(id) {
      this.$confirm('确定要删除该收款计划吗？', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteCollectionPlan(id).then(res => {
          if (res.code === 0 && res.data) {
            this.$message.success('删除成功');
            this.loadCollectionPlan();
          } else {
            this.$message.error(res.message || '删除失败');
          }
        }).catch(error => {
          console.error('删除收款计划失败：', error);
          this.$message.error('删除失败');
        });
      }).catch(() => {
        // 取消删除
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/* 颜色变量定义 */
$bg-color: #f0f2f5; /* 页面背景色 */
$primary-color: #1890ff; /* 主题蓝色 */
$border-color: #ebeef5; /* 边框颜色 */
$text-main: #303133; /* 主要文字颜色 */
$text-secondary: #606266; /* 次要文字颜色 */
$danger-color: #ff4d4f; /* 删除/红色按钮 */

.collection-plan-container {
  padding: 20px;
  background-color: $bg-color;
  min-height: 100vh;
  box-sizing: border-box;

  /* 卡片公用样式 */
  .el-card {
    border: none;
    margin-bottom: 20px;
    border-radius: 4px;
    text-align: left;
  }

  /* 查询条件标题样式 */
  .card-header {
    font-size: 14px;
    font-weight: bold;
    color: $text-main;
    text-align: left;
  }

  /* 搜索表单响应式调整 */
  .search-form {
    ::v-deep .el-form-item {
      margin-bottom: 15px;
      .el-input,
      .el-select,
      .el-date-editor {
        width: 190px;
      }
    }
  }

  /* 列表卡片样式 */
  .list-card {
    .list-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .title {
        font-size: 15px;
        font-weight: bold;
        color: $text-main;
      }
    }
  }

  /* 状态Tab样式优化 */
  .status-tabs {
    margin-bottom: 10px;
    ::v-deep .el-tabs__nav-wrap::after {
      height: 1px;
    }
  }

  /* 进度条样式微调 */
  .progress-wrapper {
    width: 90%;
    ::v-deep .el-progress__text {
      font-size: 12px !important;
      color: #999;
    }
  }

  /* 操作按钮：删除计划颜色 */
  .btn-delete {
    color: $danger-color;
    margin-left: 10px;
  }

  /* 分页居右 */
  .pagination-container {
    margin-top: 20px;
    text-align: right;
  }

  /* 合同列表分页样式 */
  .contract-pagination {
    margin-top: 20px;
    text-align: right;
  }

  /* 选中合同信息展示区域 */
  .selected-contract-info {
    margin-top: 20px;
    padding: 15px;
    background-color: #f5f7fa;
    border-radius: 4px;
    border: 1px solid #e4e7ed;

    h4 {
      margin: 0 0 15px 0;
      font-size: 14px;
      color: #303133;
      font-weight: bold;
    }
  }

  /* 收款计划详情区域 */
  .plan-detail-section {
    .contract-info-section,
    .receipt-info-section,
    .installment-section,
    .revenue-share-section {
      margin-bottom: 25px;

      h4 {
        font-size: 14px;
        font-weight: bold;
        color: #303133;
        margin-bottom: 15px;
        padding-bottom: 10px;
        border-bottom: 1px solid #e4e7ed;
      }
    }

    /* 分账明细表格 */
    .installment-table {
      margin-top: 15px;

      .installment-total {
        margin-top: 10px;
        text-align: right;
        font-size: 14px;
        color: #606266;
        font-weight: bold;
      }
    }

    /* 收入分成列表 */
    .revenue-share-list {
      margin-top: 15px;

      .revenue-share-item {
        margin-bottom: 10px;
        padding: 10px;
        background-color: #f5f7fa;
        border-radius: 4px;
      }
    }
  }
}

/* 响应式适配：针对小屏幕隐藏部分不重要列或缩小输入框 */
@media screen and (max-width: 1400px) {
  .search-form ::v-deep .el-form-item .el-input,
  .search-form ::v-deep .el-form-item .el-select,
  .search-form ::v-deep .el-form-item .el-date-editor {
    width: 150px;
  }
}
</style>